import { useAppSelector } from "../../../redux/hooks";
import { useFetch } from "../../../hooks/api";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPApps = (searchQueryFilter) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspApps", searchQueryFilter, dspAdvertiser?.id],
    "/dsp/apps",
    {
      marketplace: marketPlace,
      dsp_seller_info_id: dspAdvertiser?.id,
      appIdFilter: null,
      textQuery: searchQueryFilter,
      nextToken: null,
      maxResults: 1000,
      appType: "MOBILE",
    },
    {
      enabled: !!searchQueryFilter,
      select: (res) => {
        return res.data?.apps ?? [];
      },
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
